module.exports = __webpack_public_path__ + "static/media/Sunday.68eb499b.webp";